<template>
    <div class="orderorder">
        <!-- 单据功能按钮 -->
        <div
            style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isEdit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isEdit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isEdit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isEdit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isEdit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                >{{ $t('common.add') }}
                </el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isEdit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                >修改
                </el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isEdit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                >{{ $t('common.delete') }}
                </el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isEdit">{{ $t('common.historyBill') }}</el-button>
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-printer"
                    v-if="perData.allow_print == 1"
                    :disabled="!isEdit || nullBtn"
                    @click="printOut"
                >{{ $t('common.print') }}
                </el-button>
                <el-button type="primary" size="mini" @click="exportFile" :disabled="!isEdit">{{ $t('common.export') }}</el-button>
                <el-button type="primary" :disabled="isAdd || !isEdit || nullBtn" plain @click="Check(form.check)">{{
                        form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                    }}
                </el-button>
            </div>
        </div>
        <!-- 单据操作信息 -->
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span
                        :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                        }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 主表表单 -->
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billNo') + '：'" label-width="180">
                            <el-input v-model="form.bill_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billDate') + '：'" label-width="180" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isEdit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.bill_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.billType') + '：'" required>
                                <mySelect
                                    v-model="form.billtype_no"
                                    :options="allPullArr.billtype"
                                    values="billtype_no"
                                    labels="billtype_name"
                                    keys="billtype_no"
                                    :disable="isEdit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.customer') + '：'" label-width="180" required>
                            <mySelectOptimized
                                v-model="form.cust_no"
                                :options="allPullArr.cust"
                                values="cust_no"
                                labels="cust_name"
                                keys="cust_no"
                                :disable="isEdit"
                                @input="selectCust"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.counter') + '：'" label-width="180" required>
                            <mySelect
                                v-model="form.counter_no"
                                :options="allPullArr.counter"
                                values="counter_no"
                                labels="counter_name"
                                keys="counter_no"
                                :disable="isEdit"
                                @input="selectCounter"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.salesman') + '：'" label-width="180">
                            <mySelect
                                v-model="form.salesman_no"
                                :options="allPullArr.salesman"
                                values="salesman_no"
                                labels="salesman_name"
                                keys="salesman_no"
                                :disable="isEdit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.currency') + '：'">
                                <mySelect
                                    v-model="form.currency_no"
                                    :options="allPullArr.currency"
                                    values="currency_no"
                                    labels="currency_name"
                                    keys="currency_no"
                                    :disable="isEdit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.handler') + '：'" label-width="180">
                            <mySelect
                                v-model="form.staff_no"
                                :options="allPullArr.staff"
                                values="staff_no"
                                labels="staff_name"
                                keys="staff_no"
                                :disable="isEdit"
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="4" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allPullArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isEdit"
                                    :clearables="false"
                                    @input="selectStore"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 12 : 16">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isEdit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- 定价引用表格 -->
        <div class="inbound" v-if="systemSet.ismetalpricing == 1">
            <div class="title" @click="usedPricingTableShow = !usedPricingTableShow">
                <div>
                    定价引用
                    <i class="el-icon-caret-right" v-if="!usedPricingTableShow"></i>
                    <i class="el-icon-caret-bottom" v-else></i>
                </div>
                <div>
                    <el-button type="warning" plain @click.stop="useAllPricingData"
                               v-if="usedPricingTableShow && !isEdit">全部使用
                    </el-button>
                    <el-button type="primary" plain @click.stop="sureUsedPricingData"
                               v-if="usedPricingTableShow && !isEdit">确认
                    </el-button>
                    <el-button type="success" plain @click.stop="getUsedPricingData"
                               v-if="usedPricingTableShow && !isEdit">{{ $t('common.refresh') }}
                    </el-button>
                </div>
            </div>
            <div class="table" v-show="usedPricingTableShow">
                <vxe-table border
                           ref="usedPricingTable"
                           auto-resize height="290"
                           :data="form.usedPricingData"
                           :edit-config="{trigger: 'click', mode: 'cell'}">
                    <!--                    <vxe-table-column type="checkbox" width="50" v-if="!isEdit"></vxe-table-column>-->
                    <vxe-table-column title="序号" type="seq" field="seq" width="50" align="center"></vxe-table-column>
                    <!--                    <vxe-table-column title="定价类型编号" field="pricingtype_no" width="100"></vxe-table-column>-->
                    <vxe-table-column title="定价类型" field="pricingtype_name" width="150"></vxe-table-column>
                    <vxe-table-column title="单号" field="bill_no" width="150"></vxe-table-column>
                    <vxe-table-column title="日期" field="bill_date" width="150"></vxe-table-column>
                    <vxe-table-column title="产品编号" field="style_no" width="100"></vxe-table-column>
                    <vxe-table-column title="产品" field="style_name" width="150"></vxe-table-column>
                    <vxe-table-column title="数量" field="qty" width="100"></vxe-table-column>
                    <vxe-table-column title="单位重" field="unit_wgt" width="100"></vxe-table-column>
                    <vxe-table-column title="重量" field="wgt" width="150"></vxe-table-column>
                    <vxe-table-column
                        title="金价"
                        field="wgt_prc"
                        width="150">
                        <template #default="{ row }">
                            <span style="color: red;">{{ row.wgt_prc }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="请输入结算数量"
                        field="settle_wgt"
                        width="150"
                        :edit-render="{ name: 'input', attrs: { type: 'number' } }"
                        v-if="!isEdit"
                    >
                        <template #default="{ row }">
                            <span style="color: orange; font-weight: bold;">{{ row.settle_qty }}</span>
                        </template>
                        <template #edit="{ row }">
                            <vxe-input
                                v-model="row.settle_qty"
                                type="number"
                                @change="handleSettleWgtChange(row)"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="请输入结算重量"
                        field="settle_wgt"
                        width="150"
                        :edit-render="{ name: 'input', attrs: { type: 'number' } }"
                        v-if="!isEdit"
                    >
                        <template #default="{ row }">
                            <span style="color: orange; font-weight: bold;">{{ row.settle_wgt }}</span>
                        </template>
                        <template #edit="{ row }">
                            <vxe-input
                                v-model="row.settle_wgt"
                                type="number"
                                @change="handleSettleWgtChange(row)"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="未使用数量"
                        field="unused_qty"
                        width="150">
                        <template #default="{ row }">
                            <span style="color: blue;">{{ row.unused_qty }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="未使用重量"
                        field="unused_wgt"
                        width="150">
                        <template #default="{ row }">
                            <span style="color: blue;">{{ row.unused_wgt }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="本单使用重量"
                        field="bill_used_wgt"
                        width="150">
                        <template #default="{ row }">
                            <span style="color: green;">{{ row.bill_used_wgt }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="本单使用数量"
                        field="bill_used_wgt"
                        width="150">
                        <template #default="{ row }">
                            <span style="color: green;">{{ row.bill_used_qty }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column title="免息天数" field="swapfree_days" width="150"></vxe-table-column>
                    <vxe-table-column title="仓息率" field="swap_rate" width="150"></vxe-table-column>
                    <vxe-table-column title="保证金单价(元/克)" field="margin_prc" width="150"></vxe-table-column>
                    <vxe-table-column title="保证金" field="margin_amt" width="150"></vxe-table-column>
                    <vxe-table-column title="备注" field="remark" min-width="300"></vxe-table-column>
                </vxe-table>
            </div>
        </div>
        <!-- 明细表格 -->
        <div class="table1" @mouseleave="dtlleave">
            <div class="title" @click="dtlTableShow = !dtlTableShow">
                <div>
                    {{ $t('common.productDetail') }}
                    <i class="el-icon-caret-right" v-if="!dtlTableShow"></i>
                    <i class="el-icon-caret-bottom" v-else></i>
                </div>
            </div>
            <div v-show="dtlTableShow">
                <vxe-table
                    border
                    stripe
                    resizable
                    keep-source
                    align="center"

                    ref="dtlTable"
                    :height="maxHeight"
                    show-overflow
                    highlight-hover-row
                    :loading="loading"
                    show-footer-overflow
                    :footer-method="footerMethodDtl"
                    show-footer
                    :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true, enterToTab: true }"
                    :row-class-name="rowChange"
                    :data="form.dtl"
                    :mouse-config="{ selected: true }"
                    :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethodDtlTable }"
                    @cell-mouseenter="dtlenter"
                    :key="refushTable"
                    @checkbox-change="checkboxChangeEvent"
                    @checkbox-all="checkboxChangeEvent"
                    :scroll-y="{ enabled: true, gt: 50 }"
                    :tooltip-config="{}"
                >
                    <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                    <vxe-table-column type="seq" field="seq" width="70" title="序号">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isEdit ? changeTable(1) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                        <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                             <i class="el-icon-circle-plus-outline" @click="addDtl"></i>
                            <i class="el-icon-remove-outline" @click="delDtl(scoped)"></i>
                        </span>
                            <span v-if="scoped.$rowIndex != dtlIndex">
                            <i style="font-style: normal">{{ scoped.seq }}</i>
                        </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in rkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                            v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select'
                        "
                        >
                            <template #header="{ column }" v-if="item.batch == 1">
                                <span>{{ column.title }}</span>
                                <el-dropdown trigger="click" :hide-on-click="flagFalse">
                                    <el-button
                                        class="batchBtn"
                                        type="primary"
                                        plain
                                        :disabled="isEdit || item.column_disabled == 1"
                                        @click="batchclick"
                                    >批量
                                    </el-button
                                    >
                                    <el-dropdown-menu slot="dropdown" style="padding: 15px">
                                        <el-radio-group v-model="batchOption">
                                            <div style="display: flex">
                                                <div style="margin-right: 10px">
                                                    <div style="">
                                                        <el-radio label="1">所有行修改为</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="2">选中行及以下行修改为</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="5">选中行修改为</el-radio>
                                                    </div>
                                                </div>

                                                <div style="margin-right: 10px">
                                                    <div style="">
                                                        <el-radio label="3">所有行加减</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="4">选中行及以下行加减</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="6">选中行加减</el-radio>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-radio-group>
                                        <div style="padding-top: 5px"></div>
                                        <el-form :inline="true">
                                            <el-form-item label="">
                                                <vxe-input
                                                    style="width: 280px"
                                                    :type="item.column_type"
                                                    v-model="batchSelect"
                                                    @blur="batchOperation($event, column.property)"
                                                ></vxe-input>
                                            </el-form-item>
                                        </el-form>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type,'dtlTable')"
                                    @keydown.native="jumptable($event, row, item.field,'dtlTable')"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                    :disabled="item.column_disabled == 1"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <!--  下拉选择字段 -->
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                            <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allPullArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''), 'dtl')"
                                    @keydown.native="jumptable($event, row, item.field,'dtlTable')"
                                    :disabled="item.column_disabled == 1"
                                >
                                    <el-option
                                        v-for="option in allPullArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>

                    </template>

                    <template #empty>
                    <span style="color: red">
                        <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                    </span>
                    </template>
                </vxe-table>
            </div>
        </div>
        <!-- 页脚表单 -->
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="结算数量：">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item label="结算重量：">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                    <el-form-item label="合计金料金额：">
                        <p>{{ form.sum_metal_amt }}</p>
                    </el-form-item>
                    <el-form-item label="合计工费金额：">
                        <p>{{ form.sum_wage_amt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.totalAmt') + '：'">
                        <p>{{ form.sumamt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isEdit" @click="refreshData(form.id)" style="width: 73px">
                    {{ $t('common.cancel') }}
                </el-button>
                <el-button type="primary" :disabled="isEdit" size="mini" @click="saveItSub">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select v-model="query.model_name" placeholder="请选择模板" filterable clearable @change="selectPrints"
                       style="width: 150px">
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name"
                           :value="item.id">
                </el-option>
            </el-select>
            <div v-loading="loading" class="printBox" id="print" ref="print"
                 style="page-break-after: always; padding: 10px">
                <div v-for="(itemBig, index) in printList" style="margin-bottom: 30px" :key="index">
                    <!-- 公司名 -->
                    <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                         v-if="DataDtl.company.is_show == 1">
                        <p class="company" v-if="systemSet.company"
                           :style="`font-size:${DataDtl.company.font_size}px;`">
                            {{ systemSet.company }}
                        </p>
                    </div>
                    <!-- 单据抬头 -->
                    <div v-if="DataDtl.title">
                        <div v-if="DataDtl.title.is_show == 1">
                            <p class="printTitle" :style="`font-size:${DataDtl.title.font_size}px;`">
                                {{ itemBig.mains ? itemBig.mains.billtype_name : '' }}
                            </p>
                        </div>
                    </div>
                    <!-- 表头 -->
                    <div v-if="DataDtl.header">
                        <div v-if="DataDtl.header.is_show == 1">
                            <div class="printTop" style="margin: 5px 0 10px; padding-bottom: 5px">
                                <div>
                                    <div v-if="DataDtl.custno.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户编号：{{ itemBig.mains ? itemBig.mains.cust_no : '' }}
                                    </div>
                                    <div v-if="DataDtl.custname.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户：{{ itemBig.mains ? itemBig.mains.cust_name : '' }}
                                    </div>
                                    <div v-if="DataDtl.billremark.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        备注：{{ itemBig.mains ? itemBig.mains.remark : '' }}
                                    </div>
                                </div>
                                <div>
                                    <div v-if="DataDtl.billno.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单据编号：{{ itemBig.mains ? itemBig.mains.bill_no : '' }}
                                    </div>
                                    <div v-if="DataDtl.billdate.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单据日期：{{ itemBig.mains ? itemBig.mains.bill_date : '' }}
                                    </div>
                                    <!--                                    <div v-if="DataDtl.printdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">-->
                                    <!--                                        打印时间：{{ itemBig.mains.print_time }}-->
                                    <!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 表格1 -->
                    <div v-if="itemBig.fields1Data.length != [] && DataDtl.is_fields1 == 1"
                         :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`"
                    >
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <p class="tableName">
                                <span v-if="DataDtl.table_name1_show == 1">{{ DataDtl.table_name1 }}</span>
                            </p>
                            <p v-if="DataDtl.printdate.is_show == 1"
                               :style="`font-size:${DataDtl.header.font_size}px;`">
                                <label>打印时间：</label>{{ itemBig.mains.print_time }}
                            </p>
                        </div>
                        <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields1">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.fields1Data" :key="index">
                                <template v-for="items in fields1">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table1_total_show == 1">
                                <template v-for="(items, indexs) in fields1">
                                    <template v-if="indexs == 0"
                                    >
                                        <td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td>
                                    </template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.fields1Data_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <!-- 金额 -->
                    <div v-if="DataDtl.is_tot">
                        <div v-if="DataDtl.is_tot.is_show == 1">
                            <div class="summoney">
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                    >总计 金额大写 {{ itemBig.mains.money_type }}</span
                                    >
                                    <span
                                        :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.mains.money_chinese
                                        }}</span>
                                </div>
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                    >金额合计&nbsp;&nbsp;&nbsp; {{ itemBig.mains.money_type }}</span
                                    >
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.mains.money
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 期初存欠 -->
<!--                    <div v-if="DataDtl.custaccounts_begin">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_begin.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_begin.font_size}px;`"-->
<!--                        >-->
<!--                            <span-->
<!--                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期初存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_begin"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <!--期末存欠 -->
<!--                    <div v-if="DataDtl.custaccounts_end">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_end.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_end.font_size}px;`"-->
<!--                        >-->
<!--                            <span-->
<!--                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期末存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_end"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <!-- 本期存欠 -->
<!--                    <div v-if="DataDtl.custaccounts_now">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_now.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_now.font_size}px;`"-->
<!--                        >-->
<!--                            <span-->
<!--                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">本期存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_now"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div v-if="DataDtl.custaccounts_begin || DataDtl.custaccounts_end || DataDtl.custaccounts_now">
                        <div
                            class="sum2"
                            v-for="(accountConfig, index) in sortedCustAccounts"
                            :key="index"
                            v-if="accountConfig && accountConfig.is_show == 1"
                            :style="`font-size:${accountConfig.font_size}px;`"
                        >
                            <span
                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">{{ accountConfig.label
                                }}:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p style="width: 25%; display: flex; justify-content: space-between"
                                   v-for="(item, itemIndex) in itemBig[accountConfig.dataKey]"
                                   :key="itemIndex"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- 页脚 -->
                    <div v-if="DataDtl.footer">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div class="sumBotn" style="width: 72%; margin-right: 8%">
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`"
                                     v-show="DataDtl.footer.is_show == 1">
                                    <span>制单：</span>
                                    <span>{{ itemBig.mains.build_name || '' }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`"
                                     v-show="DataDtl.footer.is_show == 1">
                                    <span>复核：</span>
                                    <span></span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`"
                                     v-show="DataDtl.footer.is_show == 1">
                                    <span>业务员：</span>
                                    <span>{{ itemBig.mains.salesman_name || '' }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`"
                                     v-show="DataDtl.footer.is_show == 1">
                                    <span>客户签名：</span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: inline-block; text-align: right; width: 20%">
                        <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                    </div>
                    <div v-if="DataDtl.remark.is_show == 1">
                        <p :style="`font-size:${DataDtl.remark.font_size}px; white-space: pre-wrap; word-wrap: break-word;`">{{ DataDtl.remark.content }}</p>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toImg">转图片下载</el-button>
                <el-button type="primary" @click="printContext">直接打印</el-button>
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false"
                   destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index"
                                       @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost"
                                       :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2"
                                           v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { multiplication, multiplication2, getExportExcel, messageShow } from '@/utils/multAdexportExcel.js';
import {
    apiMetalPricingInSettleGetMetalPricingData,
    apiMetalPricingInSettleGetData,
    apiMetalPricingInSettleGetPull,
    apiMetalPricingInSettleUpdateData,
    apiMetalPricingInSettleAddData,
    apiMetalPricingInSettleDelData,
    apiMetalPricingInSettlecheck,
    apiInSettleDelMetalPricingData,
    apiInSettleUsedMetalPricingData,
    apiCurrentPermisson,
    apiFormatOrderAmt,
    apiSystem,
    apiMetalPricingInSettleTotalData,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiMetalPricingInSettleTempPrint,
    getPrinOut_pull
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'metalpricinginsettle',
    data() {
        return {
            usedPricingTableShow: true,
            dtlTableShow: true,
            QtyTotal: 0,
            WgtTotal: 0,
            AmtTotal: 0,
            MetalAmtTotal: 0,
            WageAmtTotal: 0,
            allPullArr: '',//存储下拉内容
            form: { remark: '' },//全局数据
            isEdit: true,//是否可编辑
            isCheck: false,//是否审核
            first: null,//是否有上一条
            last: null,//是否有下一条
            dialogImageUrl: '',
            isAdd: false,
            loading: false,
            nullBtn: false,
            systemSet: '',
            dtlIndex: '-1', //列表当前位置,
            isSave: true,
            type: '4',
            maxHeight: 336,
            showImpotDialog: false,
            headers: {},
            topIptInsjOrder: '',
            topLeftForm: {},
            billIndex: '-1',
            amtIndex: '-1',
            insertKeyword: '',
            insertKeywords: [],
            insertBillno: '',
            // 防抖
            debounceTimeout: null, // 用于存储防抖定时器
            // 批量字段
            batchSelect: '',
            selectRecords: 0,
            batchOption: '1',
            flagFalse: false,
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            zkKeyList: [],
            fkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalZkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalFkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '74',
            perData: {}, //权限

            // 打印字段
            printData: { isshow: false, scope: null, index: 0, data: {} },
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields3: [],
            fields2: [],
            fields1: [],
            query: {},
            pullList: {},
            printList: {},
            uploadData: {}
        };
    },
    computed: {
        sortedCustAccounts() {
            const accounts = [];

            if (this.DataDtl.custaccounts_begin) {
                accounts.push({
                    dataKey: 'custaccounts_begin',
                    label: '期初存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_begin.seq || 1,
                    is_show: this.DataDtl.custaccounts_begin.is_show,
                    font_size: this.DataDtl.custaccounts_begin.font_size
                });
            }

            if (this.DataDtl.custaccounts_end) {
                accounts.push({
                    dataKey: 'custaccounts_end',
                    label: '期末存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_end.seq || 2,
                    is_show: this.DataDtl.custaccounts_end.is_show,
                    font_size: this.DataDtl.custaccounts_end.font_size
                });
            }

            if (this.DataDtl.custaccounts_now) {
                accounts.push({
                    dataKey: 'custaccounts_now',
                    label: '本期存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_now.seq || 3,
                    is_show: this.DataDtl.custaccounts_now.is_show,
                    font_size: this.DataDtl.custaccounts_now.font_size
                });
            }

            return accounts.sort((a, b) => a.seq - b.seq);
        }
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getPullData();
        this.getPrintPullData();
        this.getDtlTableKey();
        this.getPermission();
        document.addEventListener('keydown.native', this.mykeyup);
        // this.geData();
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.geData();
        }
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.geData();
        }
    },
    methods: {
        selectStore(e) {
        },
        selectCounter(e) {
        },

        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '195'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        //历史单据
        goHistory() {
            this.$router.push({ path: '/MetalPricingInSettleStorageHistory', query: { page: 'MetalPricingInSettle' } });
        },

        // 单据切页
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/metalpricinginsettle' });
                this.geData(this.form.id);
                return;
            }
            this.geData(this.form.id);
        },

        // 表格内批量操作
        batchclick() {
            this.batchSelect = '';
        },
        batchOperation(e, r) {
            if (e.value) {
                var table1 = this.$refs.dtlTable.getTableData().fullData;
                if (this.batchOption == '1') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '2') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '3') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '4') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '5') {
                    // 处理多个选中的行修改为指定值
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            table1[selectedRowIndex][r] = e.value; // 修改选中行的指定列值
                        }
                    }
                } else if (this.batchOption == '6') {
                    // 处理多个选中的行加减
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            // 对选中行进行加减
                            table1[selectedRowIndex][r] = Number(table1[selectedRowIndex][r]) + Number(e.value);
                        }
                    }
                }
                for (let i = 0; i < table1.length; i++) {
                    this.calculationDtl(table1[i]);
                }
                this.flagFalse = false;
            }
        },
        checkboxChangeEvent({ records }) {
            this.selectRecords = records;
        },
        messageShow(res) {
            if (res.data.info instanceof Array) {
                let str = [];
                var s = '';
                str = res.data.info;
                for (let i = 0; i < str.length; i++) {
                    s += str[i] + '<br/>';
                }
                this.$message({
                    type: 'error',
                    showClose: true,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: s
                });
            } else {
                this.$message.success(res.data.info);
            }
        },
        // 选择客户赋值对应的业务员
        selectCust(value) {
            if (value) {
                let item = this.allPullArr.cust.filter((item) => item.cust_no == value);
                this.$set(this.form, 'salesman_no', item[0].salesman_no);
                this.$forceUpdate();
            }
            // 获取定价单
            this.getUsedPricingData();
        },
        // 定价单相关功能
        getUsedPricingData() {
            return new Promise((resolve, reject) => {
                apiMetalPricingInSettleGetMetalPricingData({
                    cust_no: this.form.cust_no,
                    id: this.form.id
                }).then((res) => {
                    if (res.code == 2000) {
                        this.form.usedPricingData = res.data.usedPricingData;
                        this.form.dtl = res.data.dtl;
                        this.$forceUpdate();
                    } else {
                        this.$message.error(res.data.info);
                    }
                    resolve(); // 成功时 resolve
                }).catch(error => {
                    reject(error); // 错误时 reject
                });
            });
        },
        sureUsedPricingData() {
            this.$load.show();
            let rowData = this.$refs.dtlTable.getTableData().fullData;
            // 确保 delUsedPricingData 完成后再执行后续操作
            this.delUsedPricingData(rowData).then(() => {
                // 获取所有行数据
                let usedPricingData = this.$refs.usedPricingTable.getTableData().fullData;

                apiInSettleUsedMetalPricingData({
                    bill_date: this.form.bill_date,
                    usedPricingData: usedPricingData
                }).then((res) => {
                    if (res.code == 2000) {
                        this.form.dtl = res.data.data;
                        this.form.usedPricingData = res.data.usedPricingData;
                        this.$forceUpdate();
                        this.$load.close();
                    } else {
                        this.$message.error(res.data.info);
                        this.$load.close();
                    }
                }).catch((res) => {
                    this.$load.close();
                });
            }).catch((error) => {
                console.error('delUsedPricingData error:', error);
                this.$load.close();
            });
        },
        delUsedPricingData(rowData) {
            return new Promise((resolve, reject) => {
                let dtl = rowData;
                let usedPricingData = this.$refs.usedPricingTable.getTableData().fullData;
                apiInSettleDelMetalPricingData({
                    usedPricingData: usedPricingData,
                    dtl: dtl
                }).then((res) => {
                    if (res.code == 2000) {
                        this.form.usedPricingData = res.data;
                        this.$forceUpdate();
                    } else {
                        this.$message.error(res.data.info);
                    }
                    resolve(); // 成功时 resolve
                }).catch((error) => {
                    reject(error); // 错误时 reject
                });
            });

        },
        // =====================================================================
        // ============================= 打印 begin =============================
        // =====================================================================
        // 打印下拉
        getPrintPullData() {
            let path_code = this.$route.path.replace('/', '');
            getPrinOut_pull({ code: path_code }).then((res) => {
                this.pullList = res.data;
                this.query.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
            });
        },
        // 打印
        printOut() {
            this.getPrintPullData();
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiMetalPricingInSettleTempPrint({
                id: this.form.id,
                print_id: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.bill;
                    //模板打印数据
                    this.DataDtl = res.data.print;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },

        // 选择打印模板事件
        selectPrints(val) {
            let modelList = this.pullList.model;
            this.printType = modelList.find((item) => item.id == val).name;
            let id = modelList.find((item) => item.id == val).id;
            this.query.model_name = val;
            this.printOutTwo();
            this.$forceUpdate();
        },
        printOutTwo() {
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiMetalPricingInSettleTempPrint({
                id: this.form.id,
                print_id: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.printList = res.data.bill;
                    //模板打印数据
                    this.DataDtl = res.data.print;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    // this.$message.error(res.data.info);
                    this.printOut();
                }
            });
        },
        // 打印页面转图片
        toImg() {
            this.$html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile(this.printType + '.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        //直接打印
        printContext() {
            this.$print(this.$refs.print);
        },

        // =====================================================================
        // ============================= 打印 end =============================
        // =====================================================================

        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isEdit) {
                    if (this.$route.path == '/metalpricinginsettle') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },

        // 获取页面信息-----------------------------------------
        geData(no) {
            this.$load.show();
            this.isEdit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiMetalPricingInSettleGetData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                if (res.code == 2000) {
                    let info = res.data;
                    this.form = info.data;
                    this.last = info.last;
                    this.first = info.first;
                    this.topLeftForm = info.data.inmain;
                    // this.maxHeight = 480;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.type = '4';
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            }).catch((error) => {
                // 处理请求错误的情况
                this.$message.error('请求失败');
                console.error(error);
            }).finally(() => {
                // 无论请求成功或失败都关闭加载提示
                this.$load.close();
            });
        },

        // =====================================================================
        // ========================= 列配置相关接口 begin =========================
        // =====================================================================
        getDtlTableKey() {
            apiGetListCorrespondingData({
                id: '114'
            }).then((res) => {
                this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '114';
            }
            this.drawers = true;
        },

        checkMove() {
        },
        // 列配置弹窗取消按钮事件
        keycancel() {
            this.drawers = false;
            this.getDtlTableKey();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // =====================================================================
        // ========================= 列配置相关接口 end =========================
        // =====================================================================
        // 全部使用：将每一行的结算数量、结算重量自动赋值为 未使用数量(重量) + 本单使用数量(重量)
        useAllPricingData() {
            if (!this.form.usedPricingData || this.form.usedPricingData.length == 0) {
                this.$message.warning('暂无定价引用数据');
                return;
            }
            this.form.usedPricingData.forEach((row) => {
                const unusedQty = Number(row.unused_qty) || 0;
                const billUsedQty = Number(row.bill_used_qty) || 0;
                const unusedWgt = Number(row.unused_wgt) || 0;
                const billUsedWgt = Number(row.bill_used_wgt) || 0;
                this.$set(row, 'settle_qty', unusedQty + billUsedQty);
                this.$set(row, 'settle_wgt', Number((unusedWgt + billUsedWgt).toFixed(this.systemSet.wgt)));
            });
            this.$message.success('已全部使用');
        },
        handleSettleWgtChange(row) {
            if (row.unit_wgt && Number(row.unit_wgt) !== 0) {
                var a = this.$utils.multiply(Number(row.settle_qty || 0), Number(row.unit_wgt || 0));
                row.settle_wgt = Number(a).toFixed(this.systemSet.wgt);
            }
            // 确保输入的使用重量不超过未使用重量
            // const unusedWgt = parseFloat(row.unused_wgt) || 0;
            // const billUsedWgt = parseFloat(row.bill_used_wgt) || 0;
            // const settleWgt = parseFloat(row.settle_wgt) || 0;
            //
            // if (settleWgt > unusedWgt + billUsedWgt) {
            //     this.$message.warning('结算重量不能超过未使用重量');
            //     this.$set(row, 'settle_wgt', unusedWgt + billUsedWgt);
            // }
        },

        // 获取下拉框信息---------------------------------------
        getPullData() {
            apiMetalPricingInSettleGetPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allPullArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        changeData(row, type, e) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allPullArr[type]; // 获取数据源

            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo); // 找到索引

            const info = arrayToSearch[idx]; // 取出相应的信息
            if (e == 'dtl') {
                if (type + '_no' == 'style_no') {
                    apiCustStyleWage({ cust_no: this.form.cust_no, style_no: selectedNo, type: 'out' }).then((res) => {
                        if (res.code == 2000) {
                            for (var item in res.data) {
                                row[item] = res.data[item];
                            }
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                }
            }
            if (!Array.isArray(arrayToSearch)) {
                console.error(`allPullArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            if (idx !== -1) {
                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
        },
        exportFile() {
            getExportExcel('billexport_metalpricinginsettle', { id: this.form.id }, '购销管理');
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isEdit = true;
            this.isAdd = false;
            this.form = { dtl: [] };
            this.type = 4;
            this.geData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/metalpricinginsettle');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            this.isSave = true;
            if (this.isEdit == true) {
                if (this.form.check == 0) {
                    this.isEdit = false;
                    if (this.form.dtl.length == 0) {
                        this.insertEventDtlTable(-1);
                    }
                } else if (this.form.check == 1) {
                    this.isCheck = true;
                }
            }
        },
        // 保存
        saveItSub() {
            this.saveIt();
        },
        // 保存修改------------------------------------------
        saveIt() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.$deepClone(this.form);
                data.dtl = this.$refs.dtlTable.getTableData().fullData;
                data.usedpricing = this.$refs.usedPricingTable.getTableData().fullData;
                data['check'] = this.form.check == true ? '1' : '0';

                this.$load.show();
                if (this.isAdd == true) {
                    apiMetalPricingInSettleAddData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isAdd = false;
                            this.isEdit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/metalpricinginsettle');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiMetalPricingInSettleUpdateData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isEdit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
                this.insertKeywords = [];
                this.dynamicTags = [];
            }
        },
        //添加-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isEdit = false;
                this.form = { bill_date: '' };
                this.topLeftForm = {};
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                // this.maxHeight = 480;
                const keys = Object.keys(this.allPullArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allPullArr[key])) {
                        // 确保 this.allPullArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allPullArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allPullArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allPullArr[key]}`);
                    }
                });
                setTimeout(() => {
                    for (let i = 0; i < 3; i++) {
                        this.insertEventDtlTable(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
            this.type = '4';
        },
        //删除单据-----------------------------------------
        delOrder() {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                apiMetalPricingInSettleDelData({
                    id: this.form.id
                }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: '删除成功', type: 'success' });
                        if (res.data.data == null) {
                            this.form = {};
                            this.nullBtn = true;
                        } else {
                            this.form = res.data.data;
                            if (this.form.check == 1) {
                                this.isCheck = true;
                            } else {
                                this.isCheck = false;
                            }
                        }
                        this.last = res.data.last;
                        this.first = res.data.first;
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            });

        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //审核按钮
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiMetalPricingInSettlecheck({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isEdit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.geData(this.form.id);
            });
        },
        //插入新数据--------------------------------------------
        async insertEventDtlTable(row) {
            let record = {
                style_no: '',
                alloy: 1,
                discount: 1
            };
            let { row: newRow } = await this.$refs.dtlTable.insertAt(record, row);
            await this.$refs.dtlTable.setActiveCell(newRow, 'seq');
        },
        delDtl(scoped) {
            let length = this.$refs.dtlTable.getTableData().fullData.length;
            if (scoped.row.metalpricing_bill_no) {
                let rowData = [scoped.row];
                this.$load.show();
                this.delUsedPricingData(rowData).then(() => {
                    this.$load.close();
                }).catch((error) => {
                    console.error('delUsedPricingData error:', error);
                    this.$load.close();
                });

                // this.$message.warning('该行数据使用定价单，不可删除！');
                // return ;
            }
            this.$refs.dtlTable.remove(scoped.row);
            if (length == 1) {
                this.addDtl();
            }
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isEdit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },

        addDtl() {
            this.insertEventDtlTable(-1);
        },
        // 不可编辑-------------------------------------
        activeRowMethodDtlTable(row) {
            if (this.isEdit == false) {
                // if (row.row.metalpricing_bill_no ) {
                //     this.$message.warning('该行数据使用定价单，不可编辑');
                //     return false;
                // }
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        // 表格行计算
        calculationDtl(row) {
            if (row.manual_metal_amt && Number(row.manual_metal_amt) !== 0) {
                let roundoff_metal_amt = Number(row.manual_metal_amt || 0) - (Number(row.wgt || 0) * (Number(row.metal_wgt_prc || 0) + Number(row.premium_discount || 0)));
                row.roundoff_metal_amt = Number(roundoff_metal_amt).toFixed(this.systemSet.amt);
            } else {
                let roundoff_metal_amt = 0;
                row.roundoff_metal_amt = Number(roundoff_metal_amt).toFixed(this.systemSet.amt);
            }
            let metal_amt = Number(row.wgt || 0) * (Number(row.metal_wgt_prc || 0) + Number(row.premium_discount || 0)) + Number(row.roundoff_metal_amt || 0);
            row.metal_amt = Number(metal_amt).toFixed(this.systemSet.amt);

            let wage_amt = Number(row.wgt || 0) * Number(row.wage_wgt_prc || 0) + Number(row.qty || 0) * Number(row.wage_qty_prc || 0);
            row.wage_amt = Number(wage_amt).toFixed(this.systemSet.amt);

            let amt = Number(row.metal_amt || 0) - Number(row.wage_amt || 0) + Number(row.swap_amt || 0) - Number(row.margin_amt || 0);
            row.amt = Number(amt).toFixed(this.systemSet.amt);
        },
        sumNum(list, field) {
            let count = 0;
            list.forEach((item) => {
                count += Number(item[field]);
            });
            return count;
        },
        // 表尾合计---------------------------------
        footerMethodDtl({ columns, data }) {
            const systemSet = this.systemSet;

            // 预计算常用的合计值，避免重复计算
            const totals = {
                qty: this.$utils.sum(data, 'qty').toFixed(systemSet.qty),
                wgt: this.$utils.sum(data, 'wgt').toFixed(systemSet.wgt),
                amt: this.sumNum(data, 'amt').toFixed(systemSet.amt),
                metal_amt: this.$utils.sum(data, 'metal_amt').toFixed(systemSet.amt),
                wage_amt: this.$utils.sum(data, 'wage_amt').toFixed(systemSet.amt)
            };

            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    }

                    switch (column.property) {
                        case 'qty':
                            this.QtyTotal = Number(totals.qty);
                            this.$set(this.form, 'qty', totals.qty);
                            this.form.sumqty = this.QtyTotal.toFixed(this.systemSet.qty);
                            return totals.qty;

                        case 'wgt':
                            this.WgtTotal = Number(totals.wgt);
                            this.$set(this.form, 'sumwgt', totals.wgt);
                            this.form.sumwgt = this.WgtTotal.toFixed(this.systemSet.wgt);
                            return totals.wgt;

                        case 'amt':
                            this.AmtTotal = Number(totals.amt);
                            this.form.sumamt2 = this.AmtTotal.toFixed(this.systemSet.amt);
                            this.form.sumamt = this.$formatOrderAmt(this.AmtTotal, this.systemSet.zero_deal, this.systemSet.amt);
                            return totals.amt;

                        case 'metal_amt':
                            this.MetalAmtTotal = Number(totals.metal_amt);
                            this.form.sum_metal_amt = this.MetalAmtTotal.toFixed(this.systemSet.amt);
                            return totals.metal_amt;

                        case 'wage_amt':
                            this.WageAmtTotal = Number(totals.wage_amt);
                            this.form.sum_wage_amt = this.WageAmtTotal.toFixed(this.systemSet.amt);
                            return totals.wage_amt;

                        default:
                            return '-';
                    }
                })
            ];
        },
        // 顶部汇总数据
        editClosedEvent() {
            this.foottotal();
        },
        foottotal() {
            let dtl = this.$refs.dtlTable.getTableData().fullData;
            apiMetalPricingInSettleTotalData({ dtl }).then((res) => {
                this.form.sumqty = res.data.sumqty;
                this.form.sumwgt = res.data.sumwgt;
                this.form.sum_wage_amt = res.data.sum_wage_amt;
                this.form.sum_metal_amt = res.data.sum_metal_amt;
                this.form.sumamt = res.data.sumamt;
                this.form.sumamt2 = res.data.sumamt2;
                this.$forceUpdate();
            });
        },

        handleInput(row, field, type, tableRef) {
            if (tableRef == 'dtlTable') {
                this.calculationDtl(row);
            }
            // 如果不是数字类型，直接返回
            if (type !== 'number') return;

            // 获取当前输入值
            let inputValue = row[field];

            // 如果输入值为空或不是字符串，设置为空字符串
            if (inputValue === null || inputValue === undefined) {
                row[field] = '';
                return;
            }

            // 转换为字符串处理
            inputValue = String(inputValue);

            // 保留数字、小数点和负号
            let cleanedValue = inputValue.replace(/[^0-9.-]/g, '');

            // 只保留第一个小数点
            const decimalIndex = cleanedValue.indexOf('.');
            if (decimalIndex !== -1) {
                cleanedValue = cleanedValue.substring(0, decimalIndex + 1) + cleanedValue.substring(decimalIndex + 1).replace(/\./g, '');
            }

            // 处理负号：只允许在开头有一个负号
            let negativeSign = '';
            if (cleanedValue.startsWith('-')) {
                negativeSign = '-';
                cleanedValue = cleanedValue.substring(1);
            }

            // 去掉中间或末尾的负号
            cleanedValue = cleanedValue.replace(/-/g, '');

            // 如果只有小数点，转换为 0.
            if (cleanedValue === '.') {
                cleanedValue = '0.';
            }

            // 合并负号和处理后的值
            row[field] = negativeSign + cleanedValue;
        }
        ,
        /**
         * 表格跳转方法
         */
        jumptable(e, row, type, tableRef) {
            // 获取指定表格的引用
            const table = this.$refs[tableRef];
            if (!table) return;

            // 所有列数据
            let column = table.getTableColumn().fullColumn;
            // 所有行数据
            var rows = table.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = table.getVTRowIndex(row);
            // 当前列
            let nowcolumn = table.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = table.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;

            // 计算需要跳过的列数
            var addnum = 1; // 跳过列的基本参数
            var addnumleft = 1;

            // 处理向右跳转时需要跳过的列
            if (column[columnIndex + 1]) {
                if (column[columnIndex + 1].className == 'jump') {
                    let newColumn = column.slice(columnIndex + 1);
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnum += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {
                    }
                }
            }

            // 处理向左跳转时需要跳过的列
            if (column[columnIndex - 1]) {
                if (column[columnIndex - 1].className == 'jump') {
                    let newColumn = column.slice(0, columnIndex).reverse();
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnumleft += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {
                    }
                }
            }

            // 右移目标列
            var jumpnum = columnIndex + addnum;
            if (column[jumpnum]) {
                var downtype = column[jumpnum].property;
            }

            // 左移目标列
            var jumpnumleft = columnIndex - addnumleft;
            if (column[jumpnumleft]) {
                var uptype = column[jumpnumleft].property;
            }

            // 右移/回车/Tab键处理
            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                // 检查是否是最后一行且最后一列
                if (jumpnum >= length && rowIndex + 1 >= rows.length) {
                    // 最后一行的最后一列，增加新行
                    if (tableRef === 'dtlTable') {
                        this.addDtl();
                    }

                    // 更新行数据
                    this.$nextTick(() => {
                        const newRows = table.getTableData().fullData;
                        if (newRows.length > rowIndex + 1) {
                            // 跳转到新行的第一列可编辑单元格
                            setTimeout(() => {
                                table.setActiveRow(newRows[rowIndex + 1]);
                            }, 100);
                        }
                    });
                } else if (jumpnum >= length) {
                    // 最后一列但不是最后一行，换行到下一行第一列
                    if (rowIndex + 1 < rows.length) {
                        setTimeout(() => {
                            table.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    }
                } else {
                    // 不是最后一列，跳转到下一列
                    let allowBreak = true;

                    if (allowBreak) {
                        table.setActiveCell(row, downtype);
                    }
                }
            }

            // 左移键处理
            if (e.keyCode == '37') {
                if (jumpnumleft < 0 && rowIndex > 0) {
                    // 第一列且不是第一行，跳转到上一行
                    table.setActiveRow(rows[rowIndex - 1]);
                } else if (jumpnumleft >= 0) {
                    // 不是第一列，跳转到上一列
                    table.setActiveCell(row, uptype);
                }
            }

            // 下箭头键处理
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 如果是最后一行，则增加新行
                if (rowIndex + 1 >= rows.length) {
                    if (tableRef === 'dtlTable') {
                        this.addDtl();
                    }

                    // 更新行数据并跳转到新行
                    this.$nextTick(() => {
                        const newRows = table.getTableData().fullData;
                        if (newRows.length > rowIndex + 1) {
                            setTimeout(() => {
                                table.setActiveCell(newRows[rowIndex + 1], nowcolumn.property);
                            }, 100);
                        }
                    });
                } else {
                    // 不是最后一行，跳转到下一行相同列
                    table.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 上箭头键处理
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保不是第一行
                if (rowIndex - 1 >= 0) {
                    // 跳转到上一行相同列
                    table.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }

    }
};
</script>

<style scoped lang="scss">
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}

.table1 {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    padding-top: 0;

    .title {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 16px;
            color: #000;
        }
    }

    .ipt {
        display: flex;
        align-items: center;
        width: 20%;

        p {
            font-size: 16px;
            color: #000;
            width: 30%;
        }
    }
}

.table_warpper {
    display: flex;

    .table2 {
        width: 60%;
        margin-right: 15px;
    }

    .table3 {
        width: 40%;
    }
}
</style>
<style>
/* .el-dialog__wrapper {
    left: 30%;
} */
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}

.vxe-table thead {
    background-color: #ecf5ff;
}

.vxe-table {
    background: #fff;
}

.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}

.box1 .el-select {
    width: 20%;
}

.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}

.el-select {
    width: 100%;
}

.list-item1:hover {
    background-color: #f5f7fa;
}

.orderorder {
    padding-bottom: 65px;
    box-sizing: border-box;
}

.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}

.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.batchBtn {
    margin-left: 5px;
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid #409eff !important;
}

.footer {
    height: 60px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;

        p {
            width: 20%; /* 调整为百分比 */
            min-width: 80px; /* 保证在极小的屏幕上也不会过小 */
        }

        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}

.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .centerItem {
        width: 48%;
        text-align: center;

        /deep/ .el-upload--text {
            width: 100%;
        }

        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }

    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;

        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}

.el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
}

.button-new-tag {
    margin-left: 10px;
}

.inbound {
    width: 100%;
    margin-top: 10px;
    background-color: #fff;

    .title {
        width: 100%;
        font-size: 16px;
        padding: 15px;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;

        i {
            color: #409eff;
        }
    }

    .table {
        padding: 0 15px;
        padding-bottom: 15px;
    }
}
</style>
